import { sampleMock } from '@/mocks/samples';
import { MedicalInterviewMock } from '@/mocks/MedicalInterviewMock';
import { UserMock } from '@/mocks/UserMock';
import { pharmacyMock } from '@/mocks/pharmacy';
import { VitalItemMock } from '@/mocks/VitalItemMock';
import { VitalDataMock } from '@/mocks/VitalDataMock';
import { VitalValueMock } from '@/mocks/VitalValue';
import { UnreadInfoNotificationMock } from '@/mocks/UnreadInfoNotificationMock';
import { OnlineReserveMock } from '@/mocks/OnlineReserveMock';
import { OnlineSettlementMock } from '@/mocks/OnlineSettlementMock';
import { ServiceListMock } from '@/mocks/ServiceListMock';
import { FollowUpMessageMock } from '@/mocks/FollowUpMessageMock';
import { TakingMedicineScheduleMock } from '@/mocks/TakingMedicineScheduleMock';
import { DeliveryAddressMock } from '@/mocks/DeliveryAddressMock';
import { PrefecturesMock } from '@/mocks/PrefecturesMock';
import { ReservationHistoryMock } from '@/mocks/ReservationHistoryMock';
import { DataShareMock } from '@/mocks/DataShareMock';
import { DataShareForViewerMock } from '@/mocks/DataShareForViewerMock';
import { EcSiteInfoMock } from './EcSiteInfoMock';
import { ServiceSiteListMock } from './ServiceSiteListMock';
import { AddressSearchMock } from './AddressSearchMock';
import { MedicineListMock } from '@/mocks/MedicineListMock';
import { CustomAlarmMock } from '@/mocks/CustomAlarmMock';
import { TermsMock } from '@/mocks/TermsMock';
import { InfoNotificationMock } from '@/mocks/InfoNotificationMock';

export const handlers = [
  // ...sampleMock,
  // ...pharmacyMock,
  // ...MedicalInterviewMock,
  // ...UserMock,
  // ...VitalItemMock,
  // ...VitalDataMock,
  // ...VitalValueMock,
  // ...UnreadInfoNotificationMock,
  // ...OnlineReserveMock,
  // ...OnlineSettlementMock,
  // ...ServiceListMock,
  // ...FollowUpMessageMock,
  // ...TakingMedicineScheduleMock,
  // ...DeliveryAddressMock,
  // ...PrefecturesMock,
  // ...ReservationHistoryMock,
  // ...DataShareMock,
  // ...DataShareForViewerMock,
  // ...EcSiteInfoMock,
  // ...ServiceSiteListMock,
  // ...AddressSearchMock,
  // ...MedicineListMock,
  // ...CustomAlarmMock,
  // ...TermsMock,
  // ...InfoNotificationMock,
];
